// Divii code — this was never part of the client's repo.
//
// The upstream builders use native confirm()/alert(). Blocking browser dialogs
// look wrong inside the agreement page, so this mixin routes them through
// bootstrap-vue's modals instead, styled to match the rest of the app
// (see ParentalPlanner.showWarningModal, Collaboration.vue, newSummary.vue).
//
// The native calls are synchronous; msgBox* return promises. Call sites become
// `await this.$confirmDialog(...)` and their enclosing method becomes async —
// that is the whole cost of the swap.

// Native dialogs render \n directly; modals do not. Split the message so
// blank-line-separated blocks become paragraphs and single newlines become
// line breaks.
function messageNodes(h, message) {
	const blocks = String(message)
		.split(/\n{2,}/)
		.filter((block) => block.trim().length);
	return h(
		'div',
		{ class: ['text-center'] },
		blocks.map((block, i) =>
			h('p', { class: i === blocks.length - 1 ? 'mb-0' : 'mb-2' }, block)
		)
	);
}

const SHARED = {
	size: 'md',
	buttonSize: 'sm',
	okVariant: 'primary',
	footerClass: 'p-2',
	hideHeaderClose: false,
	centered: true,
};

export default {
	methods: {
		/**
		 * Replaces confirm(). Resolves true only when the user accepts —
		 * dismissing via the close button or backdrop resolves null, not false.
		 */
		async $confirmDialog(message, { title = 'Please confirm', okTitle = 'Continue', cancelTitle = 'Cancel' } = {}) {
			const accepted = await this.$bvModal.msgBoxConfirm(
				[messageNodes(this.$createElement, message)],
				{ ...SHARED, title, okTitle, cancelTitle, cancelVariant: 'pastel-blue' }
			);
			return accepted === true;
		},

		/** Replaces alert(). */
		async $alertDialog(message, { title = 'Heads Up!', okTitle = 'Got it' } = {}) {
			await this.$bvModal.msgBoxOk([messageNodes(this.$createElement, message)], {
				...SHARED,
				title,
				okTitle,
			});
		},
	},
};
